import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={201}
      height={151.099}
      viewBox="0 0 201 151.099"
      {...props}
    >
      <g data-name="Asset 1">
        <g data-name="Layer 2">
          <g fill="#ddecff">
            <path
              data-name="Path 10948"
              d="M34.44 143.139S9.411 125.314 2.208 94.979s3.79-67.128 24.649-85.691 58.4-6.1 75.087 9.481l16.689 15.548a78.285 78.285 0 0036.783 7.964c20.854-.742 39.441 27.664 44.376 50.04s-6.828 51.955-6.828 51.955z"
            />
            <path
              data-name="Path 10949"
              d="M23.067 147.69a48.7 48.7 0 01-22-31.476c-4.55-22 15.168-42.094 17.065-53.091s-2.287-24.654 15.172-35.285 48.541-6.809 60.3-9.467 25.409-20.855 48.907-16.685 46.282 16.684 47.4 43.991-7.57 28.081 1.173 42.854 12.134 25.029 7.964 40.2-12.895 19.342-12.895 19.342z"
            />
            <path
              data-name="Path 10950"
              d="M59.492 142.756c-1.086-1.136-17-32.993.719-62.192s62.22-25.79 79.944-14.412 26.4 26.165 28.214 41.7-10.132 39.821-10.132 39.821z"
            />
          </g>
          <g transform="translate(15.244 11.167)">
            <rect
              data-name="Rectangle 1618"
              width={25.029}
              height={14.792}
              rx={5}
              transform="translate(146.302 63.173)"
              fill="#60a8ff"
            />
            <path
              data-name="Path 10951"
              d="M158.817 83.747l3.244-7.68h-6.484z"
              fill="#60a8ff"
            />
            <path
              data-name="Path 10952"
              d="M158.744 68.03h5.852v.857l2.869-1.654-2.869-1.659v.857h-5.852z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10953"
              d="M167.464 71.397h-5.852v-.857l-2.869 1.654 2.869 1.654v-.857h5.852z"
              fill="#fff"
            />
            <path
              data-name="Path 10954"
              d="M155.148 72.901l-.28.1a8.867 8.867 0 01-1.32-2.071 7.378 7.378 0 01-.458-2.4l.2-.082-1.237-2.965a2.442 2.442 0 00-.6.683 5.672 5.672 0 00.073 4.775 9.256 9.256 0 002.832 4.353 2.749 2.749 0 002.048.6z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10955"
              d="M156.035 72.553l-.385.137 1.269 3.034a2.487 2.487 0 00.385-.165.738.738 0 00.33-.916l-.66-1.668a.738.738 0 00-.939-.422z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10956"
              d="M153.02 64.965a3 3 0 00-.5.234l1.265 3.024.426-.179a.742.742 0 00.4-.949l-.664-1.7a.738.738 0 00-.927-.43z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10957"
              d="M38.332 126.474v-34.13s-.376-9.2 4.459-11.855 25.2-1.233 25.2-1.233v47.2z"
              fill="#1c83ff"
            />
            <path
              data-name="Path 10958"
              d="M74.378 47.308s-1.233 10.333-1.709 11.186l-.458.857-2.37 1.607s4.55 6.447 10.145 7.492 5.118-2.291 5.118-2.291l-.852-1.8 1.136-9.861s-10.158-4.628-11.01-7.19z"
              fill="#ff9d8c"
            />
            <path
              data-name="Path 10959"
              d="M66.885 61.813l3.7-1.613a17.412 17.412 0 007.868 6.163c5.5 2.277 5.6.949 5.879 0a3.634 3.634 0 00-.092-1.993l.4-3.318 2.2.733 7.634 61.748-19.626.949z"
              fill="#fff"
            />
            <path
              data-name="Path 10960"
              d="M84.995 61.12s1.329 3.066 2.562 10.269a244.882 244.882 0 012.653 27.687c.284 8.344.458 27.4.458 27.4h24.745c.289 0 1.993-9.385 1.993-9.385s-10.81-9.261-11.378-10.778c-.38-1.013-.188-19.75-1.8-28.379s-3.7-10.365-8.06-12.514a93.449 93.449 0 00-11.173-4.3z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10961"
              d="M97.89 115.608a.229.229 0 01-.229-.229c0-.678-.119-10.306-.238-19.622s-.238-18.948-.238-19.626a.229.229 0 11.458 0c0 .678.124 10.306.238 19.622s.238 18.948.238 19.626a.229.229 0 01-.229.229z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10962"
              d="M48.588 113.295l-.188 13.179h28.823s1.228-11.19.756-12.23-29.391-.949-29.391-.949z"
              fill="#223a7a"
            />
            <g data-name="Group 541">
              <path
                data-name="Path 10963"
                d="M80.66 58.21a15.048 15.048 0 004.033 2.167l.678-5.865s-7.62-3.487-10.2-6.085a15.893 15.893 0 005.489 9.783z"
                fill="#8e9bbb"
              />
            </g>
            <path
              data-name="Path 10964"
              d="M94.274 28.062a20.556 20.556 0 012.369 7.584c.38 4.175 0 14.884-3.414 19.438s-10.539 3.208-13.747.458c-2.96-2.525-5.879-5.311-6.635-10.81s1.613-15.924 8.34-18.1 13.087 1.43 13.087 1.43z"
              fill="#ff9d8c"
            />
            <path
              data-name="Path 10965"
              d="M102.839 120.512h-1.233l-1.686-.046h-.4c-.6 0-1.1.06-1.581.032h-.367a.887.887 0 01-.151 0 2.226 2.226 0 01-.628-.247 42.616 42.616 0 00-9.848-1.324c-4.234 0-8.033.307-8.652-.211s-1-5.847 2.617-6.2l4.445 1.686s10.15-1.21 13.871 1.54 3.613 4.77 3.613 4.77z"
              fill="#ff9d8c"
            />
            <path
              data-name="Path 10966"
              d="M97.94 120.466h-.367a4.3 4.3 0 00-.39-.522c-1.146-1.168-3.913-1.925-4.917-2.167a.172.172 0 11.082-.335c1.462.353 4.582 1.256 5.444 2.749a1.274 1.274 0 00.148.275z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10967"
              d="M99.919 120.448h-.4c-1.251-2.291-3.295-2.937-5.824-3.748l-.151-.05a.174.174 0 01.11-.33l.147.05c2.668.847 4.822 1.534 6.118 4.078z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10968"
              d="M101.995 120.499h-.389a9.971 9.971 0 00-6.589-4.885.172.172 0 11.06-.339 10.213 10.213 0 016.918 5.224z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10969"
              d="M75.134 40.054a8.849 8.849 0 003.556-3.79 10.805 10.805 0 001.283-5.293 16.375 16.375 0 016.635.761c3.982 1.187 8.706 2.8 12.7.518s3.982-5.925 2.039-7.442c-2.177-1.7-6.493-.664-6.493-.664s1.659-1.608.756-2.557-4.17.284-4.17.284-3.982-3.176-11.52-2.8-11.14 5.645-11.566 11.52a32.611 32.611 0 001.7 11.758z"
              fill="#223a7a"
            />
            <g data-name="Group 542">
              <path
                data-name="Path 10970"
                d="M90.424 41.48a12.176 12.176 0 00-.522 3.4c-.082.866-.243 1.883.554 2.47.38.28 2.177 1.036 1.251 1.65a2.429 2.429 0 01-1.343.151l-.834-.046c-.3-.023-.587-.115-.884-.115a.174.174 0 00-.087.321 3.763 3.763 0 001.737.412 2.631 2.631 0 001.439-.252 1.036 1.036 0 00.66-.738 1.187 1.187 0 00-.568-1.017c-.357-.266-.8-.389-1.159-.646-.5-.362-.458-.967-.426-1.526.087-1.347.394-2.672.513-4.014.023-.206-.261-.206-.33-.046z"
                fill="#8e9bbb"
              />
            </g>
            <path
              data-name="Path 10971"
              d="M94.301 44.632c-.142.8-.724 1.375-1.3 1.265s-.916-.834-.788-1.631.724-1.375 1.3-1.265a1.324 1.324 0 01.788 1.631z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10972"
              d="M87.047 44c-.128.861-.738 1.485-1.375 1.375s-1.022-.866-.916-1.728.738-1.485 1.375-1.375A1.42 1.42 0 0187.047 44z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10973"
              d="M92.616 41.34a12.921 12.921 0 001.333.032 1.076 1.076 0 01.321.032c.105.032-.142-.023-.037 0h.069l.17.037c.1.023.188.06.28.078a.916.916 0 00.27.037h.055a.688.688 0 00.183 0 .5.5 0 00.339-.6.607.607 0 00-.1-.2l-.06-.073.055.064-.06-.078a.239.239 0 00-.1-.1c-.037-.027-.069-.06-.105-.082a1.342 1.342 0 00-.412-.165 3.263 3.263 0 00-.816-.105 5.922 5.922 0 00-.806.064 1.549 1.549 0 00-.692.257.458.458 0 00-.211.458.431.431 0 00.321.371z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10974"
              d="M87.557 40.068l-.183-.092c-.055-.027-.2-.105-.092-.041l-.124-.069a2.749 2.749 0 00-.573-.2 3.813 3.813 0 00-1.329-.092 3.093 3.093 0 00-1.315.412.7.7 0 00-.165.115l-.1.124.027-.041a.458.458 0 00-.2.39.376.376 0 00.206.339.568.568 0 00.458 0h-.238a.852.852 0 00.357 0s.128-.032.046 0 .128 0 .151 0h.3c.316-.023.628-.037.916-.05s.587 0 .88 0h.454l.151.05a.431.431 0 00.518-.257.458.458 0 00-.179-.55z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10975"
              d="M89.806 53.252a4.289 4.289 0 012.145-1.929c-.8-.082-4.546-.431-5.5.11-1.059.6.2 3.015 2.387 3.139a2.9 2.9 0 00.641-.037 3.158 3.158 0 01.327-1.283z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10976"
              d="M72.48 48.16a6.863 6.863 0 002.56 3.176 25.2 25.2 0 005.338 2.956l.252-1.1a18.826 18.826 0 01-4.784-2.988 6.216 6.216 0 01-1.709-2.419z"
              fill="#dee1eb"
            />
            <path
              data-name="Path 10977"
              d="M81.013 52.367a2.749 2.749 0 012.859 2.2c.119.916-.724 1.906-2.694 1.022-2.454-1.096-1.92-3.139-.165-3.222z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10978"
              d="M73.855 37.305a18.212 18.212 0 014.408-9.165c6.97-7.066 12.895-6.64 12.895-6.64s-.046-.994-2.291-1.75a4.8 4.8 0 00-3.034-.335 17.455 17.455 0 00-10.571 5.833 22.716 22.716 0 00-5.357 12.18z"
              fill="#dee1eb"
            />
            <path
              data-name="Path 10979"
              d="M73.333 36.641c-4.582-.77-7.107 2.8-7.3 6.415a5.478 5.478 0 005.925 6.067c7.868-.627 6.97-11.533 1.375-12.482z"
              fill="#fff"
            />
            <path
              data-name="Path 10980"
              d="M71.06 45.609a3.107 3.107 0 01-2.8-1.673 3.469 3.469 0 01.133-3.583.174.174 0 11.284.2 3.111 3.111 0 00-.115 3.208 2.749 2.749 0 002.589 1.494 3 3 0 002.488-1.343 3.79 3.79 0 00.38-3.368 2.566 2.566 0 00-2.569-1.684.174.174 0 01-.192-.147.17.17 0 01.151-.192 2.869 2.869 0 012.924 1.9 4.161 4.161 0 01-.412 3.666 3.35 3.35 0 01-2.749 1.5z"
              fill="#818fb3"
            />
            <path
              data-name="Path 10981"
              d="M67.743 60.487S53.9 63.901 49.065 69.4s-7.112 32.6-7.208 37.64 3.414 7.112 5.5 8.537 11.282 3.982 18.678 4.358 14.412 0 14.412 0a9.884 9.884 0 011.114-3.982 4.91 4.91 0 012.392-2.653l-6.351-2.291S76.493 91.08 74.761 81.43a85.9 85.9 0 00-7.018-20.943z"
              fill="#223a7a"
            />
            <path
              data-name="Path 10982"
              d="M90.682 107.837a.242.242 0 01-.092-.023.229.229 0 01-.115-.3c1.3-2.924 2.639-8.67 3.4-12.7l.064-.325c.229-1.187.513-2.662-.055-3.666-.289-.518-.944-1.645-1.576-2.749s-1.269-2.186-1.443-2.507c-.335-.619.719-2.268 2.241-4.537.412-.614.765-1.146.971-1.5.545-.916.183-1.8-.234-2.791l-.142-.344a64.526 64.526 0 00-1.228-2.749l-.486-1.114-.674-1.494a87.035 87.035 0 00-4.5-9.059.22.22 0 01.078-.312.234.234 0 01.316.078 88.434 88.434 0 014.5 9.1l.669 1.494.509 1.1c.417.916.852 1.833 1.233 2.781l.142.339c.426 1.013.866 2.062.211 3.208a27.18 27.18 0 01-.99 1.526c-.793 1.182-2.447 3.666-2.218 4.069.17.312.784 1.375 1.439 2.488s1.288 2.218 1.576 2.749c.651 1.164.348 2.749.105 3.991l-.064.321c-.275 1.466-1.732 8.981-3.428 12.8a.225.225 0 01-.209.126z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10983"
              d="M77.173 108.639a.211.211 0 01-.16-.064c-1.077-1.086-6.273-10.081-6.663-11.777-.211-.916.321-3.272.834-5.545a18.372 18.372 0 00.7-4.074c-.179-.738-1.5-1.833-2.791-2.869-1.553-1.269-3.157-2.58-3.469-3.762-.353-1.343-.05-9.747.151-15.305.073-2 .128-3.579.128-4.124a.229.229 0 01.229-.229.234.234 0 01.229.229c0 .573-.06 2.154-.128 4.161-.188 5.2-.5 13.894-.165 15.172.275 1.036 1.888 2.355 3.313 3.519s2.749 2.232 2.946 3.121a16.3 16.3 0 01-.692 4.28c-.481 2.117-1.022 4.518-.834 5.343.38 1.659 5.5 10.489 6.539 11.552a.229.229 0 010 .325.211.211 0 01-.167.047z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10984"
              d="M58.532 104.707a.229.229 0 01-.2-.257c.17-1.191 2.8-24.928 2.919-26.747a.23.23 0 11.458.032c-.119 1.833-2.749 25.583-2.924 26.779a.229.229 0 01-.253.193z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10985"
              d="M77.411 111.164a.2.2 0 01-.087 0c-.582-.234-3.157-1.1-6.415-2.2-6.58-2.218-15.58-5.256-17.308-6.15a.225.225 0 01-.11-.353.229.229 0 01.312-.1c1.682.871 11.044 4.028 17.239 6.117 3.267 1.1 5.847 1.975 6.443 2.213a.229.229 0 01.124.3.225.225 0 01-.198.173z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10986"
              d="M74.245 120.603c-5.788 0-17.014-1.045-25.542-4.06a.229.229 0 01.151-.431c10.773 3.813 25.845 4.463 28.649 3.831a.235.235 0 11.1.458 18.264 18.264 0 01-3.358.202z"
              fill="#8593b6"
            />
            <path
              data-name="Path 10987"
              d="M7.969 63.686c1.8 1.581 4.074 2.594 5.65 4.422.623.719 1.182 1.485 1.755 2.236.422.55 1.54 1.462 1.723 2.154.078.3.064-.11 0-.412v-.041c-.156-1.375-.27-2.8-.321-4.2s.041-2.814-.046-4.211a6.691 6.691 0 00-2.355-5.123c-.788-.6-1.8-.971-2.529-1.645s-.412-1.375 0-2.076a7.222 7.222 0 00.985-2.08 3.712 3.712 0 00-.637-2.488c-.939-1.576-3.024-3.331-4.995-3.1-1.645.2-1.833 2.094-1.805 3.418s.147 2.566.16 3.849-.211 2.617-.229 3.932a6.819 6.819 0 002.644 5.365z"
              fill="#6baeff"
            />
            <path
              data-name="Path 10988"
              d="M24.673 84.206a21.02 21.02 0 011.783-3.4 26.215 26.215 0 002.69-4.61 16.109 16.109 0 00.632-5.316 30.291 30.291 0 00.335-3.955c-.05-.632-.412-1.659-1.233-1.553-.642.082-1.017.871-1.265 1.375a24.4 24.4 0 00-1.04 2.749c-.124.362-.243.733-.4 1.081-.092.2-.385.7-.655.628-.458-.115-.046-2.016.023-2.351a31.135 31.135 0 00.949-5.009c.105-2.52-.092-5.526-2.562-6.906a1.762 1.762 0 00-2.076-.037 3.429 3.429 0 00-.866 2.213 15.182 15.182 0 001.022 6.732 18.632 18.632 0 011.4 5.618c.055 1.86-.916 3.515-1.375 5.274a16.661 16.661 0 00-.582 5.206c0 1.136.037 2.264.119 3.4.078 1.04.17 2.085.3 3.125a5.284 5.284 0 00.078.646c-.4-.962-.541-2.071-.875-3.038-.591-1.728-1.274-3.414-1.833-5.146a41.92 41.92 0 00-1.526-4.252 10.328 10.328 0 00-2.36-3.606 3.437 3.437 0 00-2.319-.917 6.348 6.348 0 00-1.595.339 1.787 1.787 0 01-1.714-.3c-1.773-1.375-2.291-3.8-3.62-5.522-.976-1.283-3.295-3.473-5-2.071a4.076 4.076 0 00-1.1 3.276 7.974 7.974 0 001.375 3.8c.765 1.228 1.755 2.328 2.456 3.593a3.8 3.8 0 01.412 2.291 5.5 5.5 0 00.142 2.323c.811 2.291 3.341 1.975 5.311 2.035a14.737 14.737 0 014.165.687 4.633 4.633 0 013.038 2.992 10.532 10.532 0 001.338 3.208 3.441 3.441 0 001.306.976c.77.339 3.111.486 3.13.27a10.727 10.727 0 01.609-2.149 60.665 60.665 0 011.383-3.699z"
              fill="#6baeff"
            />
            <path
              data-name="Path 10989"
              d="M35.546 83.771a12.8 12.8 0 00-.784-3.964.183.183 0 00-.243-.064c-.458.247-.458.967-.5 1.411-.064.729 0 1.462-.105 2.19a16.767 16.767 0 01-.916 3.813 4.1 4.1 0 01-2.85 2.566 7.236 7.236 0 00-2.5 1.1 5.219 5.219 0 00-1.462 2.012 29.654 29.654 0 00-1.787 6.576c-.289 1.489-.522 2.979-.884 4.449a43.166 43.166 0 00-.953 4.436 4.15 4.15 0 00-.105.225c-.092.225.257.348.38.16a14.88 14.88 0 015.5-5.366c1.068-.545 2.488-.655 3.382-1.512a2.973 2.973 0 00.669-2.534 7.963 7.963 0 00-1.274-3.116 2.648 2.648 0 01-.568-1.792 2.314 2.314 0 011.159-1.4c.981-.609 2.135-.884 2.937-1.769a4.793 4.793 0 001.246-2.933 20.309 20.309 0 00-.342-4.488z"
              fill="#6baeff"
            />
            <path
              data-name="Path 10990"
              d="M16.135 91.341a18.9 18.9 0 00-4.482-4.147c-.916-.6-3.056-1.8-3.492 0-.252 1.045.77 2.071 1.443 2.749a27.311 27.311 0 013.034 2.969 8.8 8.8 0 00-3.079 1.132 2.429 2.429 0 00-.495 3.6 6.721 6.721 0 001.874 1.15c.852.412 1.718.788 2.589 1.15a21.86 21.86 0 015.393 2.873 8.739 8.739 0 013.3 5.673c0 .2-.064 0 .06-.078.064.06.289-.046.289-.165a22.587 22.587 0 00-1.9-9.114 38.08 38.08 0 00-4.534-7.792z"
              fill="#6baeff"
            />
            <path
              data-name="Path 10991"
              d="M11.791 61.756a97.274 97.274 0 002.19 4.248 34.56 34.56 0 012.035 4.124 180.938 180.938 0 002.117 5.279 51.443 51.443 0 011.957 5.591 66.654 66.654 0 012.241 11.378 46.576 46.576 0 01.229 5.875c-.041 1.535-.215 3.052-.357 4.582a26.935 26.935 0 00-.128 4.784c.115 1.333.325 2.914 1.375 3.863a.238.238 0 00.371-.289c-1.228-2.516-1.159-5.256-.916-7.987.128-1.508.307-3.006.357-4.518a44.909 44.909 0 00-.192-5.769 67.675 67.675 0 00-2.112-11.149 50.4 50.4 0 00-1.833-5.5c-.715-1.81-1.54-3.565-2.232-5.38a73.471 73.471 0 00-4.848-9.256c-.087-.16-.316 0-.243.137z"
              fill="#43588e"
            />
            <path
              data-name="Path 10992"
              d="M22.362 88.614a27.125 27.125 0 011.214-6.979c.376-1.063.834-2.1 1.2-3.166a6.052 6.052 0 00.518-3.029.105.105 0 00-.206 0c-.156.536-.137 1.123-.247 1.673a16.092 16.092 0 01-.422 1.581c-.353 1.1-.816 2.163-1.214 3.249a16.084 16.084 0 00-1 6.672.083.083 0 10.165 0z"
              fill="#43588e"
            />
            <path
              data-name="Path 10993"
              d="M8.497 74.867c.953 2.291 3.8 2.429 5.884 2.942a5.5 5.5 0 013.363 2.653 20.164 20.164 0 011.92 4.628h.033c-.582-2.749-1.411-6.062-4.248-7.332-2.268-1.022-5.261-.509-6.713-2.96-.073-.124-.293-.041-.238.1z"
              fill="#43588e"
            />
            <path
              data-name="Path 10994"
              d="M20.86 88.252c.115.151.22.312.335.458a1.337 1.337 0 00.188.206.458.458 0 00.266.133.06.06 0 00.05-.087 1.043 1.043 0 00-.2-.179l-.206-.183c-.133-.124-.252-.261-.385-.389-.023 0-.073 0-.05.041z"
              fill="#43588e"
            />
            <path
              data-name="Path 10995"
              d="M14.929 95.524a23.273 23.273 0 014.349 4.679 27.924 27.924 0 011.581 2.6 29.116 29.116 0 011.283 3.02c.032.078.17.082.16 0-.229-2.158-1.595-4.01-2.685-5.8a13.808 13.808 0 00-2.035-2.461 18.208 18.208 0 00-2.507-2.209c-.11-.082-.252.1-.147.188z"
              fill="#43588e"
            />
            <path
              data-name="Path 10996"
              d="M27.963 92.985c-.788.458-.811 1.7-.829 2.488-.027 1.531.348 2.965-.321 4.422a34.449 34.449 0 01-2.332 3.634 7.926 7.926 0 00-1.4 3.982c0 .078.124.124.16.041a16.3 16.3 0 00.6-1.989 8.344 8.344 0 01.971-2.053 33.679 33.679 0 002.227-3.386 8 8 0 00.49-3.955c0-.889-.115-2.314.6-2.974a.133.133 0 00-.16-.211z"
              fill="#43588e"
            />
            <path
              data-name="Path 10997"
              d="M22.693 107.654c-3.18-.046-9.229-.078-9.229-.078l1.5 11.117a5.041 5.041 0 004.995 4.385h5.465a5.041 5.041 0 005-4.367l1.49-11.117s-6.045.012-9.221.06z"
              fill="#fff"
            />
            <path
              data-name="Path 10998"
              d="M176.249 87.221l-18.123 35.9-52.839.38 16.3-36.787z"
              fill="#f6f7fa"
            />
            <path
              data-name="Path 10999"
              d="M70.217 123.28v-2.873h34.2l15.74-34.51h54.714l1.375 1.324h-53.44l-16.354 36.027s-36.235-.064-36.235.032z"
              fill="#d9dee8"
            />
            <path
              data-name="Path 11000"
              d="M148.805 107.04c-.6 1.787-3.835 3.171-7.236 3.089s-5.673-1.608-5.077-3.4 3.84-3.171 7.24-3.089 5.673 1.604 5.073 3.4z"
              fill="#d9dee8"
            />
            <path
              data-name="Path 11001"
              d="M106.454 123.477a.237.237 0 01-.1 0 .229.229 0 01-.115-.3l16.442-36.182h53.566a.229.229 0 110 .458h-53.292l-16.308 35.889a.22.22 0 01-.193.135z"
              fill="#fff"
            />
            <path
              data-name="Rectangle 1619"
              fill="#596b9b"
              d="M4.977 125.997h62.856v13.935H4.977z"
            />
            <path
              data-name="Rectangle 1620"
              fill="#7a89af"
              d="M67.476 125.997h113.093v13.935H67.476z"
            />
            <path
              data-name="Path 11002"
              d="M67.833 125.997H4.977v2.562h175.592v-2.562z"
              fill="#bdc4d7"
            />
            <path
              data-name="Rectangle 1621"
              fill="#6f7fa9"
              d="M1.944 123.248h68.639v3.414H1.944z"
            />
            <path
              data-name="Rectangle 1622"
              fill="#9ca6c3"
              d="M70.226 123.248h113.093v3.414H70.226z"
            />
            <rect
              data-name="Rectangle 1623"
              width={27.164}
              height={16.052}
              rx={5.43}
              transform="translate(27.289 34.079)"
              fill="#fff"
            />
            <path
              data-name="Path 11003"
              d="M60.777 42.103l-8.335-3.515v7.029z"
              fill="#fff"
            />
            <circle
              data-name="Ellipse 545"
              cx={1.535}
              cy={1.535}
              r={1.535}
              transform="translate(34.071 40.568)"
              fill="#223a7a"
            />
            <circle
              data-name="Ellipse 546"
              cx={1.535}
              cy={1.535}
              r={1.535}
              transform="translate(39.336 40.568)"
              fill="#223a7a"
            />
            <circle
              data-name="Ellipse 547"
              cx={1.535}
              cy={1.535}
              r={1.535}
              transform="translate(44.601 40.568)"
              fill="#223a7a"
            />
            <path
              data-name="Path 11004"
              d="M164.935 0h-51.227a5.957 5.957 0 00-5.957 5.957v24.287a5.957 5.957 0 005.957 5.957h4.582a21.05 21.05 0 01-2.025 9.673 25.735 25.735 0 0011.1-9.673h37.576a5.957 5.957 0 005.957-5.957V5.957A5.957 5.957 0 00164.932 0z"
              fill="#60a8ff"
            />
            <path
              data-name="Path 11005"
              d="M143.081 11.58h-25.409a1.265 1.265 0 01-1.265-1.26 1.265 1.265 0 011.265-1.265h25.409a1.265 1.265 0 011.265 1.265 1.265 1.265 0 01-1.265 1.26z"
              fill="#fff"
            />
            <path
              data-name="Path 11006"
              d="M161.302 18.944h-44.116a.774.774 0 01-.774-.774.774.774 0 01.774-.774h44.116a.774.774 0 01.788.774.774.774 0 01-.793.774z"
              fill="#d2e6ff"
            />
            <path
              data-name="Path 11007"
              d="M161.302 23.243h-44.116a.774.774 0 01-.774-.774.774.774 0 01.774-.774h44.116a.774.774 0 01.788.774.774.774 0 01-.793.774z"
              fill="#d2e6ff"
            />
            <path
              data-name="Path 11008"
              d="M151.678 27.826h-34.492a.774.774 0 01-.774-.774.774.774 0 01.774-.774h34.5a.774.774 0 01.788.774.774.774 0 01-.793.774z"
              fill="#d2e6ff"
            />
            <path
              data-name="Path 11009"
              d="M160.952 11.58h-12.12a1.265 1.265 0 01-1.265-1.26 1.265 1.265 0 011.265-1.265h12.12a1.26 1.26 0 011.265 1.265 1.26 1.26 0 01-1.265 1.26z"
              fill="#fff"
            />
            <rect
              data-name="Rectangle 1624"
              width={15.594}
              height={11.236}
              rx={2}
              transform="translate(115.724 56.235)"
              fill="#fff"
            />
            <path
              data-name="Path 11010"
              d="M123.601 63.534a.339.339 0 01-.22-.082l-7.492-6.186a.35.35 0 11.458-.527l7.254 6 7.08-6.159a.346.346 0 01.458.518l-7.3 6.351a.353.353 0 01-.238.085z"
              fill="#6f7fa9"
            />
            <path
              data-name="Path 11011"
              d="M116.128 67.215a.344.344 0 01-.247-.582l5.238-5.5a.339.339 0 01.486 0 .344.344 0 010 .486l-5.238 5.5a.339.339 0 01-.238.1z"
              fill="#6f7fa9"
            />
            <path
              data-name="Path 11012"
              d="M130.933 67.013a.325.325 0 01-.243-.1l-5.233-5.238a.344.344 0 01.486-.486l5.219 5.233a.344.344 0 010 .486.339.339 0 01-.229.105z"
              fill="#6f7fa9"
            />
            <circle
              data-name="Ellipse 548"
              cx={4.596}
              cy={4.596}
              r={4.596}
              transform="translate(127.441 51.291)"
              fill="#ff5f42"
            />
            <text
              data-name={8}
              transform="translate(131.038 57.402)"
              fill="#fff"
              fontSize={3}
              fontFamily="SegoeUI-Bold, Segoe UI"
              fontWeight={700}
            >
              <tspan x={0} y={0}>
                {"8"}
              </tspan>
            </text>
            <rect
              data-name="Rectangle 1625"
              width={30.528}
              height={7.868}
              rx={3.934}
              transform="translate(149.524 46.328)"
              fill="#223a7a"
            />
            <path
              data-name="Path 11013"
              d="M153.295 52.326a.371.371 0 01-.289-.128.458.458 0 01-.1-.325l.115-1.017v-.05c0-.009-.037 0-.064 0l-.839.6a.385.385 0 01-.321.082.394.394 0 01-.27-.2.371.371 0 01-.046-.357.389.389 0 01.238-.22l.939-.426a.036.036 0 00.041-.041s0-.027-.041-.037l-.939-.426a.394.394 0 01-.234-.243.431.431 0 01.041-.334.394.394 0 01.27-.2.408.408 0 01.321.069l.839.619c.027 0 .046.023.064 0s.023 0 0-.05l-.115-1.017a.422.422 0 01.1-.325.408.408 0 01.312-.128.385.385 0 01.385.458l-.115 1.017v.05c0 .009.037 0 .064 0l.839-.6a.39.39 0 01.325-.082.362.362 0 01.266.2.385.385 0 01.046.357.4.4 0 01-.238.22l-.944.426a.039.039 0 00-.037.037c0 .014 0 .032.037.041l.944.426a.413.413 0 01.238.243.38.38 0 01-.046.335.362.362 0 01-.266.2.417.417 0 01-.325-.069l-.839-.619c-.027 0-.05-.023-.064 0s-.023.023 0 .05l.115 1.017a.376.376 0 01-.1.325.431.431 0 01-.307.122z"
              fill="#fff"
            />
            <path
              data-name="Path 11014"
              d="M158.849 52.326a.371.371 0 01-.289-.128.458.458 0 01-.1-.325l.115-1.017v-.05a.069.069 0 00-.069 0l-.834.6a.394.394 0 01-.325.082.4.4 0 01-.27-.2.385.385 0 01-.046-.357.4.4 0 01.238-.22l.944-.426a.04.04 0 00.037-.041c0-.018 0-.027-.037-.037l-.944-.426a.376.376 0 01-.229-.243.412.412 0 01.037-.335.4.4 0 01.27-.2.422.422 0 01.325.069l.834.619a.069.069 0 00.069 0v-.052l-.115-1.017a.426.426 0 01.105-.325.422.422 0 01.6 0 .385.385 0 01.087.325l-.106 1.017v.05c0 .009.037 0 .064 0l.839-.6a.394.394 0 01.33-.082.376.376 0 01.266.2.38.38 0 01.041.357.39.39 0 01-.238.22l-.939.426a.04.04 0 00-.041.037c0 .014 0 .032.041.041l.939.426a.389.389 0 01.238.243.366.366 0 01-.041.335.375.375 0 01-.266.2.422.422 0 01-.33-.069l-.839-.619c-.027 0-.046-.023-.064 0s-.023.023 0 .05l.115 1.017a.376.376 0 01-.1.325.417.417 0 01-.316.128z"
              fill="#fff"
            />
            <path
              data-name="Path 11015"
              d="M164.408 52.326a.371.371 0 01-.289-.128.458.458 0 01-.1-.325l.119-1.017v-.05c0-.009-.037 0-.064 0l-.839.6a.39.39 0 01-.321.082.394.394 0 01-.27-.2.371.371 0 01-.046-.357.39.39 0 01.238-.22l.939-.426a.036.036 0 00.041-.041s0-.027-.041-.037l-.939-.426a.385.385 0 01-.234-.243.413.413 0 01.041-.334.394.394 0 01.27-.2.412.412 0 01.321.069l.839.619c.027 0 .046.023.064 0s.023 0 0-.05l-.119-1.017a.458.458 0 01.105-.325.408.408 0 01.312-.128.385.385 0 01.385.458l-.114 1.017v.05a.069.069 0 00.069 0l.839-.6a.39.39 0 01.325-.082.362.362 0 01.266.2.385.385 0 01.046.357.417.417 0 01-.238.22l-.944.426a.039.039 0 00-.037.037c0 .014 0 .032.037.041l.944.426a.412.412 0 01.238.243.38.38 0 01-.046.335.362.362 0 01-.266.2.417.417 0 01-.325-.069l-.839-.619a.069.069 0 00-.069 0v.05l.114 1.017a.376.376 0 01-.1.325.431.431 0 01-.312.122z"
              fill="#fff"
            />
            <path
              data-name="Path 11016"
              d="M169.96 52.326a.371.371 0 01-.289-.128.458.458 0 01-.1-.325l.115-1.017v-.05c0-.009-.037 0-.064 0l-.839.6a.385.385 0 01-.321.082.4.4 0 01-.27-.2.385.385 0 01-.046-.357.4.4 0 01.238-.22l.944-.426a.04.04 0 00.037-.041c0-.018 0-.027-.037-.037l-.944-.426a.376.376 0 01-.229-.243.412.412 0 01.037-.335.4.4 0 01.27-.2.408.408 0 01.321.069l.839.619c.028 0 .05.023.064 0s.023 0 0-.05l-.115-1.017a.458.458 0 01.1-.325.412.412 0 01.312-.128.4.4 0 01.3.128.385.385 0 01.087.325l-.11 1.016v.05c0 .009.037 0 .064 0l.839-.6a.394.394 0 01.33-.082.362.362 0 01.261.2.371.371 0 01.046.357.39.39 0 01-.238.22l-.939.426a.04.04 0 00-.041.037c0 .014 0 .032.041.041l.939.426a.4.4 0 01.238.243.367.367 0 01-.046.335.362.362 0 01-.261.2.421.421 0 01-.33-.069l-.82-.6c-.027 0-.046-.023-.064 0s-.023.023 0 .05l.115 1.017a.376.376 0 01-.1.325.431.431 0 01-.334.11z"
              fill="#fff"
            />
            <path
              data-name="Path 11017"
              d="M175.519 52.326a.367.367 0 01-.289-.128.459.459 0 01-.1-.325l.119-1.017v-.05a.06.06 0 00-.064 0l-.839.6a.39.39 0 01-.321.082.4.4 0 01-.275-.2.38.38 0 01-.041-.357.39.39 0 01.238-.22l.939-.426a.036.036 0 00.041-.041s0-.027-.041-.037l-.939-.426a.371.371 0 01-.234-.243.43.43 0 01.037-.334.4.4 0 01.275-.2.412.412 0 01.321.069l.839.619a.06.06 0 00.064 0s.023 0 0-.05l-.119-1.017a.426.426 0 01.105-.325.408.408 0 01.312-.128.385.385 0 01.385.458l-.092 1.04v.05a.069.069 0 00.069 0l.834-.6a.4.4 0 01.33-.082.367.367 0 01.266.2.385.385 0 01.046.357.417.417 0 01-.238.22l-.944.426a.039.039 0 00-.037.037c0 .014 0 .032.037.041l.944.426a.412.412 0 01.238.243.38.38 0 01-.046.335.367.367 0 01-.266.2.431.431 0 01-.33-.069l-.834-.619a.069.069 0 00-.069 0v.05l.115 1.017a.376.376 0 01-.1.325.431.431 0 01-.339.1z"
              fill="#67acff"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
